import React, { useEffect, Fragment, useState, useRef } from "react";
import Breadcrumb from "../../../components/common/breadcrumb";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { GetCountries } from "../../../api/masters/countryAPI";
import { useForm } from "react-hook-form";
import { showToast } from "../../../components/ToastifyNotification";
import { UncontrolledTooltip } from "reactstrap";
import {
  GetStateById,
  GetStates,
  UpdateState
} from "../../../api/masters/stateAPI";
import { GetCityById, UpdateCity } from "../../../api/masters/cityAPI";
import useKeyboardSubmit from "../../../hooks/useKeyboardSubmit";
import useEnterNavigation from "../../../hooks/useEnterNavigation";

// Validation schema using Yup
const schema = yup.object().shape({
  name: yup.string().required("Name is required"),
  countryId: yup.string().required("Country is required"),
  stateId: yup.string().required("State is required")
});

const EditCountry = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);

  const { id } = useParams();

  const { register, handleSubmit, setValue, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });

  const fetchCountry = async () => {
    try {
      const response = await GetCountries(); // Make sure login function returns token
      if (response.success) {
        setCountries(response.data);
      } else {
        // setError(response.message);
        showToast("error", response.message);
      }
    } catch (error) {
      // setError(error); // Handle login errors
      showToast("error", error);
    }
  };

  const fetchStates = async countryId => {
    try {
      const response = await GetStates(countryId); // Make sure login function returns token
      if (response.success) {
        setStates(response.data);
      } else {
        // setError(response.message);
        showToast("error", response.message);
      }
    } catch (error) {
      // setError(error); // Handle login errors
      showToast("error", error);
    }
  };

  const fetchData = async () => {
    try {
      const response = await GetCityById(id); // Make sure login function returns token

      if (response.success) {
        setValue("name", response.data.name); // Set default values
        setValue("countryId", response.data.countryId);
        setValue("stateId", response.data.stateId);
      } else {
        // setError(response.message);
        showToast("error", response.message);
      }
    } catch (error) {
      // setError(error); // Handle login errors
      showToast("error", error);
    }
  };

  useEffect(
    () => {
      const loadData = async () => {
        try {
          dispatch({ type: "LOADER_START" });

          await fetchCountry();
          await fetchStates();
          await fetchData();
        } catch (error) {
          showToast("error", error);
        } finally {
          dispatch({ type: "LOADER_STOP" });
        }
      };

      loadData();
    },
    [id]
  );

  const onSubmit = async data => {
    try {
      dispatch({ type: "LOADER_START" });

      const response = await UpdateCity(id, data);
      if (response.success) {
        showToast("success", response.message);
      } else {
        showToast("error", response.message);
      }
    } catch (error) {
      showToast("error", error);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  const formRef = useRef(null);
  useKeyboardSubmit(handleSubmit, onSubmit);
  useEnterNavigation(formRef);

  return (
    <Fragment>
      <Breadcrumb parent="City" title="Edit City" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <h5>Edit City</h5>
                  <Link to={`/masters/city/list`}>
                    <button className="btn btn-primary" id="list">
                      List City
                    </button>
                    <UncontrolledTooltip placement="top" target="list">
                      List City
                    </UncontrolledTooltip>
                  </Link>
                </div>
              </div>
              <form
                ref={formRef}
                className="form theme-form"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="name">Select Country*</label>
                        <select
                          className="form-select"
                          id="name"
                          type="text"
                          {...register("countryId")}
                          onChange={e => {
                            fetchStates(e.target.value);
                          }}
                        >
                          <option value="">Select Country</option>
                          {countries.map(country =>
                            <option value={country._id}>
                              {country.name}
                            </option>
                          )}
                        </select>
                        {errors.countryId &&
                          <p className="text-danger">
                            {errors.countryId.message}
                          </p>}
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="name">Select State*</label>
                        <select
                          className="form-select"
                          id="name"
                          type="text"
                          {...register("stateId")}
                        >
                          <option value="">Select State</option>
                          {states.map(state =>
                            <option value={state._id}>
                              {state.name}
                            </option>
                          )}
                        </select>
                        {errors.stateId &&
                          <p className="text-danger">
                            {errors.stateId.message}
                          </p>}
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="name">City Name*</label>
                        <input
                          className="form-control"
                          id="name"
                          type="text"
                          placeholder="City Name"
                          {...register("name")}
                        />
                        {errors.name &&
                          <p className="text-danger">
                            {errors.name.message}
                          </p>}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer text-end">
                  <button className="btn btn-primary me-2" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default EditCountry;
